import { ArticleNonParagraphProps } from "@routes/Article/components/ArticleParagraphElements/utils/types";
import { cn } from "@util/helpers";
import parse, { DOMNode, domToReact } from "html-react-parser";

/**
 * Renders a table element in an article.
 * This component processes the body string to extract table elements
 * and applies appropriate styles and classes.
 */
const Table = ({
  bodyString,
  className,
  paragraphWidth,
}: ArticleNonParagraphProps) => {
  if (!bodyString) return <></>;

  const transformTable = (
    node: DOMNode
  ): string | boolean | void | object | null => {
    if (!node || node.type !== "tag") return null;

    const children = node.children as DOMNode[];

    if (node.name === "table") {
      return (
        <table
          className={cn(
            "mb-6 w-full border-collapse border border-gray-200",
            className,
            paragraphWidth
          )}
          data-testid="article-table-component"
        >
          <tbody>{domToReact(children, { replace: transformTable })}</tbody>
        </table>
      );
    }

    if (node.name === "tr") {
      return (
        <tr className="border-b border-gray-200">
          {domToReact(children, { replace: transformTable })}
        </tr>
      );
    }

    if (node.name === "td" || node.name === "th") {
      return (
        <td className="border-r border-gray-200 px-2">
          {domToReact(children)}
        </td>
      );
    }
  };

  return <>{parse(bodyString, { replace: transformTable })}</>;
};

export default Table;
